import React from "react";

const KeyResponsibilities = () => {
  return (
    <section>
      <section className="key-responsibilities ">
        <h2 className="kr-title">Key Responsibilities:</h2>
        <ul>
          <li>Responsible for accurately documenting the patient’s medical history as required by the consulting physician.</li>
          <li>Assists gynaecologists, obstetricians, and paediatricians in procedures involving mothers, paediatric patients, and neonates.</li>
          <li>Ensures all investigations are carried out as advised by the doctor.</li>
          <li>Handles emergencies competently and calmly; provides timely guidance and decision-making.</li>
          <li>Ensures the Nursing Supervisor (NS) is immediately informed of any incidents.</li>
          <li>Ensures medication safety and adheres to patient safety protocols.</li>
          <li>Upholds patient rights and maintains the confidentiality of both medical and personal patient information; prevents any violation by avoiding discussions of patient-identifiable information in non-secure areas.</li>
          <li>Provides health education and counseling to patients and their attendants.</li>
          <li>Implements infection control practices.</li>
          <li>Complies with NABH and Nursing Excellence standards.</li>
          <li>Competently handles all equipment used in patient care; ensures the team is trained in its usage and that equipment is functional and readily available.</li>
          <li>Maintains records, reports, and registers in accordance with organizational standards.</li>
          <li>Accurately captures data, ensures documentation is complete and correct, tracks Nursing Quality Indicators, and reports accurately.</li>
          <li>Responsible for inventory management and cost control; ensures no misuse or wastage of resources.</li>
          <li>Coordinates with the Billing team regarding investigations and billing activities.</li>
          <li>Collaborates closely with the Clinical Services team to ensure the delivery of efficient patient care.</li>
        </ul>
      </section>
    </section>
  );
};

export default KeyResponsibilities;
